export default function () {
  const config = useRuntimeConfig()
  const host = useHost().value

  return {
    enabled: computed(() => [config.public.careerDomain, config.public.mobilityDomain].includes(host)),
    mobility: computed(() => host === config.public.mobilityDomain)
  }
}
